export default "__VITE_ASSET__Ci5abKAR__"